import React from 'react';
import { SparklesIcon } from 'lucide-react';
export function Results() {
  return <section className="py-16 md:py-24 bg-emerald-50/50" data-id="element-171">
      <div className="container mx-auto px-4" data-id="element-172">
        <div className="max-w-4xl mx-auto" data-id="element-173">
          <div className="text-center mb-12" data-id="element-174">
            <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-6" data-id="element-175">
              Resultados que puedes sentir
            </h2>
            <p className="text-stone-600" data-id="element-176">
              Sin promesas falsas ni kilos garantizados. Hablamos de sensaciones
              reales.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-177">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-emerald-100 flex items-center" data-id="element-178">
              <div className="h-10 w-10 rounded-full bg-emerald-100 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-179">
                <SparklesIcon className="h-5 w-5 text-emerald-600" data-id="element-180" />
              </div>
              <p className="font-medium text-stone-800" data-id="element-181">
                Abdomen menos tenso y visiblemente menos hinchado
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-emerald-100 flex items-center" data-id="element-182">
              <div className="h-10 w-10 rounded-full bg-emerald-100 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-183">
                <SparklesIcon className="h-5 w-5 text-emerald-600" data-id="element-184" />
              </div>
              <p className="font-medium text-stone-800" data-id="element-185">
                Sensación de ligereza al despertar
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-emerald-100 flex items-center" data-id="element-186">
              <div className="h-10 w-10 rounded-full bg-emerald-100 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-187">
                <SparklesIcon className="h-5 w-5 text-emerald-600" data-id="element-188" />
              </div>
              <p className="font-medium text-stone-800" data-id="element-189">
                Menos sueño y pesadez después de comer
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-emerald-100 flex items-center" data-id="element-190">
              <div className="h-10 w-10 rounded-full bg-emerald-100 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-191">
                <SparklesIcon className="h-5 w-5 text-emerald-600" data-id="element-192" />
              </div>
              <p className="font-medium text-stone-800" data-id="element-193">
                Control real sobre la urgencia de dulce
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}